import axios from 'axios';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import rectangleImage from '../../images/image.png';
import { FUTURE_EVENTS } from '../ApiDetails.js';

export default function FutureEvents() {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const navigate = useNavigate();
    useEffect(() => {
        const fetchEvents = async () => {
            axios.get(FUTURE_EVENTS)
                .then((response) => {
                    setEvents(response.data);
                })
                .catch((error) => {
                    console.error('Error fetching future events:', error);
                    setError(error.message);
                })
                .finally(() => {
                    setLoading(false);
                });
        };

        if (loading) fetchEvents();
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    if (!Array.isArray(events) || events.length === 0) {
        return <div>No events found.</div>;
    }

    // Sort events by eventDate in ascending order
    const sortedEvents = [...events].sort((a, b) => new Date(a.eventDate) - new Date(b.eventDate));

    // Select the top 3 upcoming events
    const upcomingEvents = sortedEvents.slice(0, 3);

    return (
        <div className="futureevents bg-light p-3 rounded">
            <h6 className="card-header-custom card-title">
                MY {upcomingEvents >= 3 ? 3 : ''} FUTURE EVENTS
            </h6>
            {upcomingEvents.map((event, index) => (
                <div key={index} onClick={() => { const url = `/getDetailMarsComplete/${event.eventId}`; navigate(url); }} style={{ cursor: 'pointer' }}>
                    <div className="card mb-3" style={{ maxWidth: 540 }}>
                        <div className="row g-0">
                            <div className="col-md-4">
                                {event.coverImage ? (
                                    <img
                                        src={event.coverImage}
                                        className="img-fluid rounded-start"
                                        alt={event.eventTitle}
                                    />) : (<img
                                        src={rectangleImage}
                                        className="img-fluid rounded-start"
                                        alt={event.eventTitle}
                                    />)}
                            </div>
                            <div className="col-md-8">
                                <div className="card-body p-2">
                                    <h6 className="card-header-custom2 card-title" title={event.eventTitle}>
                                        {event.eventTitle.substring(0, 80)}
                                    </h6>

                                    <p className="card-text-custom card-text">
                                        {new Date(event.eventDate).toLocaleDateString('en-US', {timeZone: 'UTC'})} {event.eventType} {event.cityName}
                                    </p>
                                    <Link to={`/getDetailMarsComplete/${event.eventId}`} className={`card-footer-button btn rounded-pill ${event.eventStatus}`}>
                                        {event.eventStatus === "Attendance confirmed" ? "CONFIRMED" : event.eventStatus.toUpperCase()}
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}